/**
 * 파일명 : com0108p.jsx
 * 설명 : 휴가등록
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 *     
 */

/************************************************
 * Import 영역  
 ************************************************/
/************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Com0108pAction } from '../../../redux/slice/com/com0108p_slice';
import { IOffItemState, IComCdState } from '../../../redux/models/com/com0108p_model';

/* AntD */
import { Input, Layout, Row, Col, Space, Button, Descriptions, Radio, Select } from 'antd';

/* 업무 */
import * as commonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';

/************************************************
 * 전역변수 선언영억
 ************************************************/

const Com0108p = (props:any) => {
    /************************************************
     * Render 변수 선언 및 셋팅영역
     ************************************************/
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
    const dispatch = useAppDispatch();
    const offItem        = useAppSelector((state) => state.Com0108p.offItem);
    const halfOffDcdList = useAppSelector((state) => state.Com0108p.halfOffDcdList);
    const isEditMode     = useAppSelector((state) => state.Com0108p.isEditMode);

    /* AntD */
    const { Content } = Layout;

    React.useEffect(() => {
        const option = {
            useYn: 'Y',
            callback: (datas:IComCdState[]) => {
                let arrOptions:IComCdState[] = [];
                datas.forEach((item:IComCdState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd
                    });
                });

                dispatch(Com0108pAction.setHalfOffDcdList(arrOptions));
            }
        };
        common.getComCodeList('033', option);

        if (props.cd) {
            // 입력파라미터
            const requestData = {
                cd : props.cd,
                cdGrpId : '008',
                useYn: 'ALL'
            };

            /* 트렌젝션 호출 및 결과 셋팅 */
            commonProxy.callAsyncSvc(requestData, {
                txCd : 'TRCOMR0001',
                success : (responseData:any) => {
                    dispatch(Com0108pAction.setOffItem(responseData.codeItems[0]));
                    dispatch(Com0108pAction.setIsEditMode(false));
                },
            });
        }

        return () => {
            btnReset_onClick();
        }
    }, []);


    /************************************************
     * 이벤트 함수 영역
     ************************************************/
	/**
     * 기능 : 저장버튼 클릭 이벤트
     * 설명 : 등록/수정
     * param : 
     * return : None
     */

    const btnSave_onClick = () => {
        /* 정합성 체크 */
        if (common.isEmptyString(offItem.cd)) {
            const param = {
                title : '위드정보 확인',
                contents: '[휴가구분코드]는 필수 입력항목 입니다.',
            };

            common.openInfo(param);
            return false;
        }

        if (common.isEmptyString(offItem.cdNm)) {
            const param = {
                title : '위드정보 확인',
                contents: '[휴가구분명]은 필수 입력항목 입니다.',
            };

            common.openInfo(param);
            return false;
        }

        // 입력파라미터
        const requestData = {
            ...offItem
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd : props.cd ? 'TRCOMS0004' : 'TRCOMS0003',
            success : (responseData:any) => {
                dispatch(Com0108pAction.setOffItem(responseData.codeItems));
                dispatch(Com0108pAction.setIsEditMode(false));

                const param = {
                    title : '위드정보 확인',
                    contents: '정상적으로 처리 되었습니다.',
                };
    
                common.openAlert(param);
            },
        });
    };

	/**
     * 기능 : 화면 닫기
     * 설명 : 화면 닫기
     * param : 
     * return : None
     */
    const btnClose_onClick = () => {
        props.cancel();
    }

	/**
     * 기능 : 초기화
     * 설명 : 입력컴포넌트
     * param : 
     * return : None
     */
    const btnReset_onClick = React.useCallback(() => {
        dispatch(Com0108pAction.initState());
    }, []);

    /**
     * 기능 : onClick 이벤트 선언
     * param : 
     */
    const onClick = async (e:any, record:IOffItemState) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnReset': {
                btnReset_onClick();
                break;
            }
            case 'btnSave': {
                btnSave_onClick();
                break;
            }
            case 'btnClose': {
                btnClose_onClick();
                break;
            }
            default:
        }
    };

    /************************************************
     * 개발자함수 영역
     ************************************************/

    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Descriptions bordered column={2} size='small'>
                    <Descriptions.Item label='* 휴가구분코드'>
                        <Input id='inputCd' value={offItem.cd} disabled={!isEditMode} placeholder='1 부터 1씩 증가시키며 입력하세요' onChange={(e:any) => {
                            dispatch(Com0108pAction.setOffItem({ ...offItem, cd : e.currentTarget.value }));
                        }}/>
                    </Descriptions.Item>
                    <Descriptions.Item label='* 휴가구분명'>
                        <Input id='inputCdNm' name='cdNm' value={offItem.cdNm} onChange={(e:any) => {
                            dispatch(Com0108pAction.setOffItem({ ...offItem, cdNm : e.currentTarget.value }));
                        }}/>
                    </Descriptions.Item>
                    <Descriptions.Item label='* 사용여부'>
                        <Radio.Group value={offItem.useYn} name='offItems.useYn' onChange={(e:any) => {
                            dispatch(Com0108pAction.setOffItem({ ...offItem, useYn : e.target.value }));
                        }}>
                            <Radio key='useYn_Y' value='Y'>사용</Radio>
                            <Radio key='useYn_N' value='N'>미사용</Radio>
                        </Radio.Group>  
                    </Descriptions.Item>
                    <Descriptions.Item label='* 공가여부'>
                        <Radio.Group value={offItem.attr1} name='offItems.attr1' onChange={(e:any) => {
                            dispatch(Com0108pAction.setOffItem({ ...offItem, attr1 : e.target.value }));
                        }}>
                            <Radio key='attr1_Y' value='Y'>공가</Radio>
                            <Radio key='attr1_N' value='N'>비공가</Radio>
                        </Radio.Group>  
                    </Descriptions.Item>
                    <Descriptions.Item label='* 반차여부'>
                        <Select 
                            style={{
                                width: 200,
                            }}
                            optionFilterProp='label'
                            options={halfOffDcdList}
                            value={offItem.attr2}
                            onChange={val => dispatch(Com0108pAction.setOffItem({...offItem, attr2: val}))}
                        ></Select>
                    </Descriptions.Item>
                </Descriptions>

                <Row justify='center'>
                    <Col>
                        <Space direction='vertical'>
                            <Row justify='space-around' style={{ marginTop: 20 }}>
                                <Space size='small'>
                                    <Button
                                        name='btnReset'
                                        className='background-color-default-button'
                                        disabled={!common.isAdmin()}
                                        onClick={(e:any) => onClick(e, null)}
                                        >
                                        초기화
                                    </Button>
                                    <Button
                                        name='btnSave'
                                        className='background-color-primary-button'
                                        disabled={!common.isAdmin()}
                                        onClick={(e:any) => onClick(e, null)}
                                    >
                                        저장
                                    </Button>
                                    <Button
                                        name='btnClose'
                                        className='background-color-default-button'
                                        onClick={(e:any) => onClick(e, null)}
                                    >
                                        닫기
                                    </Button>
                                </Space>
                            </Row>
                        </Space>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
}

export default Com0108p;